import ActionCreator from "../../utils/helpers/actionCreator";
import * as BookingConstants from "../constants/booking.constants";
import BookingService from "../../utils/services/booking.service";


export const getQuoteLeads = filter => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIP_QUOTE_LEADS_REQUEST));
		const { data: responseData } = await BookingService.getQuoteLeads(filter);
		await dispatch(ActionCreator(BookingConstants.FETCH_TRIP_QUOTE_LEADS_SUCCESS, responseData));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIP_QUOTE_LEADS_FAILURE));
	}
};

export const getTrips = filter => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIPS_REQUEST));
		const { data: responseData } = await BookingService.getTrips(filter);
		await dispatch(ActionCreator(BookingConstants.FETCH_TRIPS_SUCCESS, responseData));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIPS_FAILURE));
	}
};

export const getTripInfo = payload => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIP_DETAILS_REQUEST));
		const { data: responseData } = await BookingService.getTripInfo(payload);
		await dispatch(ActionCreator(BookingConstants.FETCH_TRIP_DETAILS_SUCCESS, responseData.data));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIP_DETAILS_FAILURE));
	}
};

export const getPickList = (reference) => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_PICKLIST_REQUEST));
		const { data: responseData } = await BookingService.fetchPicklist(reference);
		await dispatch(ActionCreator(BookingConstants.FETCH_PICKLIST_SUCCESS, responseData.data));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_PICKLIST_FAILURE));
	}
};

export const getTripPoolQuotes = tripPoolId => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIP_POOL_QUOTES_REQUEST));
		const { data: responseData } = await BookingService.getTripPoolQuotes(tripPoolId);
		await dispatch(ActionCreator(BookingConstants.FETCH_TRIP_POOL_QUOTES_SUCCESS, responseData.data));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIP_POOL_QUOTES_FAILURE));
	}
};

export const getTripPoolConfiguration = () => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_ORG_TRIP_POOL_CONFIG_REQUEST));
		const { data: responseData } = await BookingService.getTripPoolConfiguration();
		await dispatch(ActionCreator(BookingConstants.FETCH_ORG_TRIP_POOL_CONFIG_SUCCESS, responseData));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_ORG_TRIP_POOL_CONFIG_FAILURE));
	}
};

export const getTripPoolSubOrganisations = () => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIP_POOL_SUB_ORGANISATIONS_REQUEST));
		const { data: responseData } = await BookingService.getTripPoolSubOrganisations();
		await dispatch(ActionCreator(BookingConstants.FETCH_TRIP_POOL_SUB_ORGANISATIONS_SUCCESS, responseData.data));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIP_POOL_SUB_ORGANISATIONS_FAILURE));
	}
};

export const getOrganisationTripTypes = () => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_ORGANISATION_TRIP_TYPES_REQUEST));
		const { data: responseData } = await BookingService.getOrganisationTripTypes();
		await dispatch(ActionCreator(BookingConstants.FETCH_ORGANISATION_TRIP_TYPES_SUCCESS, responseData.data));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_ORGANISATION_TRIP_TYPES_FAILURE));
	}
};

export const getOrganisationBookingProfile = () => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_ORGANISATION_PROFILE_REQUEST));
		const { data: responseData } = await BookingService.getOrganisationBookingProfile();
		await dispatch(ActionCreator(BookingConstants.FETCH_ORGANISATION_PROFILE_SUCCESS, responseData.data));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_ORGANISATION_PROFILE_FAILURE));
	}
};

export const getOrganisationAddedServices = () => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_ADDED_SERVICES_REQUEST));
		const { data: responseData } = await BookingService.getOrganisationAddedServices();
		await dispatch(ActionCreator(BookingConstants.FETCH_ADDED_SERVICES_SUCCESS, responseData.data));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_ADDED_SERVICES_FAILURE));
	}
};

/********************** INVENTORY **********************/
export const getInventoryProfile = () => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_INVENTORY_PROFILE_REQUEST));
		const { data: responseData } = await BookingService.getOrganisationInventoryProfile();
		await dispatch(ActionCreator(BookingConstants.FETCH_INVENTORY_PROFILE_SUCCESS, responseData.data));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_INVENTORY_PROFILE_FAILURE));
	}
};
/********************** RECONCILIATION **********************/

export const getReconciliationProfile = () => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_RECONCILIATION_PROFILE_REQUEST));
		const { data: responseData } = await BookingService.getOrganisationReconciliationProfile();
		await dispatch(ActionCreator(BookingConstants.FETCH_RECONCILIATION_PROFILE_SUCCESS, responseData.data));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_RECONCILIATION_PROFILE_FAILURE));
	}
};

/*******************PRODUCT*********************/
export const getProducts = filter => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_PRODUCTS_REQUEST));
		const { data: responseData } = await BookingService.getProducts(filter);
		dispatch(ActionCreator(BookingConstants.FETCH_PRODUCTS_SUCCESS, responseData));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_PRODUCTS_FAILURE));
	}
};

export const getProductInformation = filter => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_PRODUCT_INFORMATION_REQUEST));
		const { data: responseData } = await BookingService.getProducts(filter);
		dispatch(ActionCreator(BookingConstants.FETCH_PRODUCT_INFORMATION_SUCCESS, responseData.data));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_PRODUCT_INFORMATION_FAILURE));
	}
};

export const getProductCategories = () => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_PRODUCT_CATEGORIES_REQUEST));
		const { data: responseData } = await BookingService.getProductCategories();
		dispatch(ActionCreator(BookingConstants.FETCH_PRODUCT_CATEGORIES_SUCCESS, responseData));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_PRODUCT_CATEGORIES_FAILURE));
	}
};

/*******************ORDERS AND ORDERSETS*********************/
export const getOrderSets = filter => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_ORDER_SETS_REQUEST));
		const { data: responseData } = await BookingService.getOrderSets(filter);
		dispatch(ActionCreator(BookingConstants.FETCH_ORDER_SETS_SUCCESS, responseData));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_ORDER_SETS_FAILURE));
	}
};

export const getOrderSetInfo = filter => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_ORDER_SETS_INFORMATION_REQUEST));
		const { data: responseData } = await BookingService.getOrderSets(filter);
		dispatch(ActionCreator(BookingConstants.FETCH_ORDER_SETS_INFORMATION_SUCCESS, responseData.data));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_ORDER_SETS_INFORMATION_FAILURE));
	}
};

export const getPreparedManifest = (filter) => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_PREPARED_ORDER_SETS_REQUEST));
		const { data: responseData } = await BookingService.getOrderSets(filter);
		dispatch(ActionCreator(BookingConstants.FETCH_PREPARED_ORDER_SETS_SUCCESS, responseData));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_PREPARED_ORDER_SETS_FAILURE));
	}
};

export const getTripByOrderSetReference = filter => async dispatch => {
	try {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIP_BY_ORDER_SETS_REFERENCE_REQUEST));
		const { data: responseData } = await BookingService.getTripByOrderSetReference(filter);
		dispatch(ActionCreator(BookingConstants.FETCH_TRIP_BY_ORDER_SETS_REFERENCE_SUCCESS, responseData));
	} catch (error) {
		dispatch(ActionCreator(BookingConstants.FETCH_TRIP_BY_ORDER_SETS_REFERENCE_FAILURE));
	}
};
